import React from 'react';
import styled, { css } from 'styled-components';
import Button from '../Button/Button';

const ButtonWrapper = styled(Button)`
  font-size: ${props => props.theme.fonts.sizeBase};
  text-align: center;
  padding: 10px 20px;
  background: ${props => props.theme.colors.white10};
  color: ${props => props.theme.colors.primary};

  ${props =>
    props.danger &&
    css`
      background: ${props => props.theme.colors.danger10};
      color: ${props => props.theme.colors.danger};
    `};

  ${props =>
    props.success &&
    css`
      background: ${props => props.theme.colors.success10};
      color: ${props => props.theme.colors.success};
    `};

  ${props =>
    props.warning &&
    css`
      background: ${props => props.theme.colors.warning10};
      color: ${props => props.theme.colors.warning};
    `};
`;

function ColoredButton({ children, ...props }) {
  return <ButtonWrapper {...props}>{children}</ButtonWrapper>;
}

export default ColoredButton;
